module.exports = __webpack_public_path__ + "img/logo_top.063e25a7.png";